import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import {
  computed,
  watch,
  type PropType,
} from 'vue';

import type {
  AsyncFunc,
  Options,
  OptionsGetterAsyncProp,
} from './OptionsGetter.types';


export default /*@__PURE__*/_defineComponent({
  __name: 'OptionsGetter',
  props: {
  options: {
    type: Array as PropType<Options>,
    required: false,
    default: () => [],
  },
  async: {
    type: Object as PropType<OptionsGetterAsyncProp>,
    required: false,
    default: null,
  },
},
  setup(__props) {

const props = __props;

// We can't use computed function here
// 'cause Vue starts throwing us warnings in the runtime
// with something with incorrect usage of onBeforeUnmount events...
// IDK why it happens, so a solution is just to do almost the same
// but in `watch` function
let optionsGetter: ReturnType<AsyncFunc> | null = null;

watch(() => props.async, (asyncValue) => {
  if (asyncValue) {
    optionsGetter = asyncValue.func();
  } else {
    optionsGetter = null;
  }
}, { immediate: true });

const data = computed(() => (optionsGetter ? optionsGetter.data.value : null));
const loading = computed<boolean>(() => (optionsGetter ? optionsGetter.loading.value : false));

const options = computed(() => {
  if (props.async && data.value) {
    return props.async.mapper(data.value);
  }

  return props.options || [];
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    options: options.value,
    loading: loading.value
  })
}
}

})